import {RouterModule, Routes} from '@angular/router';

import {AffiliateComponent} from '../affiliate/affiliate.component';
import {ModuleWithProviders} from '@angular/core';
import {AffiliateModule} from './affiliate.module';
import {CreateLinkComponent} from './create-link/create-link.component';
import {LinkControlComponent} from './link-control/link-control.component';
import {ManageSettingComponent} from './manage-setting/manage-setting.component';
import {CampaignSettingComponent} from './campaign-setting/campaign-setting.component';
import { SymbolListComponent } from './symbol-list/symbol-list.component';
import { CreateAccountComponent } from './create-account/create-account.component';
import { RankingComponent } from './ranking/ranking.component';
import { TradingVolumeListComponent } from './trading-volume/trading-volume.component';


export const routes: Routes = [
  {
    path: '',
    component: AffiliateComponent,
    children: [
      { path: '', redirectTo: 'create', pathMatch: 'full' },
      {
        path: 'create', component: CreateLinkComponent
      },
      {
        path: 'list', component: LinkControlComponent
      },
      {
        path: 'setting', component: CampaignSettingComponent
      },
      {
        path: 'manager', component: ManageSettingComponent
      },
      {
        path: 'symbol-list', component: SymbolListComponent
      },
      {
        path: 'create-mt5-account', component: CreateAccountComponent
      },
      {
        path: 'ib-ranking', component: RankingComponent
      },
      {
        path: 'trading-volumn', component: TradingVolumeListComponent
      },
      {
        path: 'default-setting',
        loadChildren: () => import('./default-setting/default-setting.module').then((m) => m.DefaultSettingModule),
      },
    ]
  },
];

export const routing: ModuleWithProviders<AffiliateModule> = RouterModule.forChild(routes);
